import React, { createContext, useContext, useEffect, useState } from "react";
import BlockRenderer from "./BlockRenderer";
import { useSite } from "../contexts/SiteContext";
import { api } from "../lib/api";

// Ce que le CMS a chargé pour la page, offert aux pages qui gardent leur code
// afin qu'elles y prennent leur illustration.
const ContenuDePage = createContext({});
export const usePageContent = () => useContext(ContenuDePage);

/**
 * Renders a marketing page from CMS blocks if an admin has built them; otherwise the
 * provided fallback (the original page). Registers per-page SEO (applied centrally by <Seo>).
 */
export default function CmsPage({ page, children, append = false }) {
  const { setPageSeo } = useSite();
  const [data, setData] = useState(null);
  const [ctx, setCtx] = useState({});

  useEffect(() => {
    let active = true;
    setData(null);
    api.get(`/content?page=${page}`).then(({ data }) => active && setData(data)).catch(() => active && setData({ blocks: [], seo: {} }));
    api.get("/startups?limit=6").then(({ data }) => active && setCtx((c) => ({ ...c, startups: data.items }))).catch(() => {});
    api.get("/stats").then(({ data }) => active && setCtx((c) => ({ ...c, stats: data }))).catch(() => {});
    api.get("/partners").then(({ data }) => active && setCtx((c) => ({ ...c, partners: data.items }))).catch(() => {});
    return () => { active = false; };
  }, [page]);

  useEffect(() => {
    const seo = data?.seo;
    setPageSeo(seo && (seo.title || seo.description) ? seo : null);
    return () => setPageSeo(null);
  }, [data, setPageSeo]);

  const sansBlocs = !data || !data.blocks || data.blocks.length === 0;
  // `append` : la page de code reste, les blocs viennent à la suite. Sans cela,
  // ajouter un seul bloc efface tout ce que la page affichait.
  return (
    <ContenuDePage.Provider value={data || {}}>
      {sansBlocs ? children : (
        <div className="flex flex-col">
          {append ? children : null}
          <BlockRenderer blocks={data.blocks} ctx={ctx} />
        </div>
      )}
    </ContenuDePage.Provider>
  );
}
